const handleImageCompare = (id) => {
  const sliderID = `#image-comparison-slider-${id}`;
  const slider = document.querySelector(sliderID);
  const sliderImgWrapper = document.querySelector(`${sliderID} .img-wrapper`);
  const sliderHandle = document.querySelector(`${sliderID} .handle`);
  const sliderImg = document.querySelector(`${sliderID} .img-wrapper img`);
  sliderImg.style.width =
    slider.parentNode.getBoundingClientRect().width + "px";
  sliderImg.style.minWidth =
    slider.parentNode.getBoundingClientRect().width + "px";

  slider.addEventListener("mousemove", sliderMouseMove);
  slider.addEventListener("touchmove", sliderMouseMove);

  function sliderMouseMove(event) {
    if (isSliderLocked) return;

    const sliderLeftX = slider.offsetLeft;
    const sliderWidth = slider.clientWidth;
    const sliderHandleWidth = sliderHandle.clientWidth;

    let mouseX = (event.clientX || event.touches[0].clientX) - sliderLeftX;
    if (mouseX < 0) mouseX = 0;
    else if (mouseX > sliderWidth) mouseX = sliderWidth;

    sliderImgWrapper.style.width = `${(
      (1 - mouseX / sliderWidth) *
      100
    ).toFixed(4)}%`;

    sliderHandle.style.left = `calc(${((mouseX / sliderWidth) * 100).toFixed(
      4
    )}% - ${sliderHandleWidth / 2}px)`;
  }

  let isSliderLocked = false;

  slider.addEventListener("mousedown", sliderMouseDown);
  slider.addEventListener("touchstart", sliderMouseDown);
  slider.addEventListener("mouseup", sliderMouseUp);
  slider.addEventListener("touchend", sliderMouseUp);
  slider.addEventListener("mouseleave", sliderMouseLeave);

  function sliderMouseDown(event) {
    if (isSliderLocked) isSliderLocked = false;
    sliderMouseMove(event);
  }

  function sliderMouseUp() {
    if (!isSliderLocked) isSliderLocked = true;
  }

  function sliderMouseLeave() {
    if (isSliderLocked) isSliderLocked = false;
  }
};

const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = resolve;
    img.onerror = reject;
  });
};

const handleImageCompareV2 = async (node, imageSrc) => {
  try {
    const imageEle = document.querySelector(node);
    if (imageEle) {
      await preloadImage(imageSrc);
      imageEle.src = imageSrc;
    }
  } catch (error) {
    console.log("handleImageCompare ~ error:", error);
  }
};

function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ");
  const trident = ua.indexOf("Trident/");

  return msie > 0 || trident > 0;
}

document.addEventListener("DOMContentLoaded", function () {
  if (!isIE()) return;
  const hiddenInput = document.querySelector(
    '#{{ product_form_id }} input[name="id"]'
  );
  const noScriptInputWrapper = document.createElement("div");
  const variantSwitcher =
    document.querySelector('variant-radios[data-section="{{ section.id }}"]') ||
    document.querySelector('variant-selects[data-section="{{ section.id }}"]');
  noScriptInputWrapper.innerHTML = document.querySelector(
    ".product-form__noscript-wrapper-{{ section.id }}"
  ).textContent;
  variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

  document
    .querySelector("#Variants-{{ section.id }}")
    .addEventListener("change", function (event) {
      hiddenInput.value = event.currentTarget.value;
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("._rsi-cod-form-embed-container");
  const showNowButton = document.querySelector(".confirm-button");
  let mouseInForm = false;
  let anyInputFocused = false;
  if (form && showNowButton) {
    // Sự kiện khi di chuột vào form
    form.addEventListener("mouseover", () => {
      mouseInForm = true;
      if (!anyInputFocused) {
        showNowButton.style.display = "none";
      }
    });
    // Sự kiện khi di chuột ra khỏi form
    form.addEventListener("mouseout", () => {
      mouseInForm = false;
      if (!anyInputFocused) {
        showNowButton.style.display = "block";
      }
    });
    // Sự kiện khi một phần tử input nhận focus
    document.addEventListener("focusin", function (event) {
      var focusedElement = event.target;
      if (focusedElement.tagName === "INPUT") {
        anyInputFocused = true;
        if (!mouseInForm) {
          showNowButton.style.display = "none";
        }
      }
    });
    // Sự kiện khi một phần tử input mất focus
    document.addEventListener("focusout", function (event) {
      var focusedElement = event.target;
      if (focusedElement.tagName === "INPUT") {
        anyInputFocused = false;
        if (!mouseInForm) {
          showNowButton.style.display = "block";
        }
      }
    });
    // Sự kiện khi di chuột ra khỏi document
    document.addEventListener("mouseout", function (event) {
      if (!mouseInForm && !anyInputFocused) {
        showNowButton.style.display = "block";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  function padNumber(num) {
    return num.toString().padStart(2, "0");
  }

  function updateCountdown(elements, value) {
    if (!elements.length) return;
    if (elements.length === 1) {
      elements[0].innerHTML = value;
      return;
    }
    elements.forEach((el, idx) => {
      el.innerHTML = value.charAt(idx);
    });
  }

  function startCountdown({
    containerSelector,
    minuteSelectors,
    secondSelectors,
    duration,
  }) {
    const container = document.querySelector(containerSelector);
    const minuteElements = minuteSelectors.map((sel) =>
      document.querySelector(sel)
    );
    const secondElements = secondSelectors.map((sel) =>
      document.querySelector(sel)
    );

    if (
      !container ||
      minuteElements.includes(null) ||
      secondElements.includes(null)
    )
      return;

    let totalSeconds = duration;

    const timer = setInterval(() => {
      let minutes = padNumber(Math.floor(totalSeconds / 60));
      let seconds = padNumber(totalSeconds % 60);

      updateCountdown(minuteElements, minutes);
      updateCountdown(secondElements, seconds);

      if (totalSeconds <= 0) {
        clearInterval(timer);
        console.log("Countdown complete!");
        return;
      }

      totalSeconds--;
    }, 1000);
  }

  startCountdown({
    containerSelector: ".countdown",
    minuteSelectors: [".countdown-minus"],
    secondSelectors: [".countdown-second"],
    duration: 10 * 60,
  });

  startCountdown({
    containerSelector: ".countdown-container-v2",
    minuteSelectors: [".countdown-minus-1", ".countdown-minus-2"],
    secondSelectors: [".countdown-second-1", ".countdown-second-2"],
    duration: 8 * 60,
  });

  startCountdown({
    containerSelector: ".countdown-v3",
    minuteSelectors: [".countdown-minus"],
    secondSelectors: [".countdown-second"],
    duration: 5 * 60,
  });

  startCountdown({
    containerSelector: ".countdown-v4",
    minuteSelectors: [".countdown-minus"],
    secondSelectors: [".countdown-second"],
    duration: 10 * 60,
  });
});
